export class ItemImprovementMessageEnv {
  itemImprovementMessage: string;
  largeClassType: string;
  smallClassType: string;
  supplierId: string;
  catalogItemCode: string;
  itemGroupCode: string;
  fromScreenType: string;

  constructor(
    itemImprovementMessage: string,
    largeClassType: string,
    smallClassType: string,
    supplierId: string,
    catalogItemCode: string,
    itemGroupCode: string,
    fromScreenType: string
  ) {
    this.itemImprovementMessage = itemImprovementMessage;
    this.largeClassType = largeClassType;
    this.smallClassType = smallClassType;
    this.supplierId = supplierId;
    this.catalogItemCode = catalogItemCode;
    this.itemGroupCode = itemGroupCode;
    this.fromScreenType = fromScreenType;
  }
}
